import React, { useState } from 'react';
import JourneySelector from '../components/AdventureBuilder/JourneySelector';
import DecisionEngine from '../components/AdventureBuilder/DecisionEngine';
import FinalMasterpiece from '../components/AdventureBuilder/FinalMasterpiece';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AdventureBuilder = () => {
  const [stage, setStage] = useState('selector'); // 'selector', 'builder', 'masterpiece'
  const [selectedJourney, setSelectedJourney] = useState(null);
  const [adventureData, setAdventureData] = useState(null);

  const handleJourneySelect = (journey) => {
    setSelectedJourney(journey);
    setStage('builder');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleBuilderComplete = (data) => {
    setAdventureData(data);
    setStage('masterpiece');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleFinalSubmit = async (fullData) => {
    try {
      // Save adventure profile to backend
      await axios.post(`${API}/adventure-profiles`, fullData);
      
      // Send email notification
      const emailData = {
        name: fullData.contactInfo.name,
        email: fullData.contactInfo.email,
        phone: fullData.contactInfo.phone,
        tour: fullData.journey.name,
        message: `Adventure Builder Submission\n\nJourney: ${fullData.journey.name}\nDuration: ${fullData.totalDays} days\nCost: $${fullData.totalCost}\nPersona: ${fullData.persona.persona}\n\nCustom Choices:\n${fullData.choicesSummary.join('\n')}`
      };
      
      await axios.post(`${API}/contact`, emailData);
      
      return true;
    } catch (error) {
      console.error('Error saving adventure profile:', error);
      throw error;
    }
  };

  return (
    <div>
      {stage === 'selector' && (
        <JourneySelector onSelectJourney={handleJourneySelect} />
      )}
      
      {stage === 'builder' && selectedJourney && (
        <DecisionEngine 
          journey={selectedJourney} 
          onComplete={handleBuilderComplete}
        />
      )}
      
      {stage === 'masterpiece' && adventureData && (
        <FinalMasterpiece 
          adventureData={adventureData}
          onSubmit={handleFinalSubmit}
        />
      )}
    </div>
  );
};

export default AdventureBuilder;